import {gsap} from 'gsap'
/**
 * Animate scroll for anchor links
 * @return {void}
 */
export const smoothScroll = function(event) {
  event.preventDefault();
	if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
		const $target = document.querySelector(this.hash)
		if ($target) {
			event.stopPropagation();
			event.preventDefault();
			let pos = $target.getBoundingClientRect();
			gsap.to(
				document.querySelectorAll('html, body'),
				{
					duration: 0.5,
					scrollTop: window.scrollY + pos.top,
					ease: "expo.out"
				}
			)
			return false
		}
	}
}
